import { render } from "./Santa.vue?vue&type=template&id=178d9734&scoped=true"
import script from "./Santa.vue?vue&type=script&lang=js"
export * from "./Santa.vue?vue&type=script&lang=js"

import "./Santa.vue?vue&type=style&index=0&id=178d9734&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-178d9734"

export default script